<template>
  <md-field class='input' :class='{ "md-invalid": errors.length }'>
    <label v-if='label'>
      {{ label }}
    </label>
    <md-input
      :value="value"
      @input="onChange"
      @blur.native="onBlur"
      :placeholder="placeholder"
      :disabled="disabled"
      v-bind="inputProps"
    />

    <template v-if="errors.length">
      <span
        class='md-error'
        v-for='(error, index) in errors'
        :key="`error-${index}`"
      >
        {{ $t(`errors.${error}`) }}
      </span>
    </template>

    <div
      v-if='suffix'
      class='suffix'
    >
      <span>{{ suffix }}</span>
    </div>
  </md-field>
</template>

<script>
  export default {
    name: 'x-input',
    model: {
      prop: 'value',
      event: 'update'
    },
    props: {
      inputProps: {
        type: Object,
        default: () => ({})
      },
      value: {
        type: [String, Number]
      },
      label: {
        type: String,
        default: null
      },
      placeholder: {
        type: [String, Number],
        default: null
      },
      errors: {
        type: Array,
        default: () => []
      },
      disabled: {
        type: Boolean,
        default: false
      },
      suffix: {
        type: String,
        required: false
      }
    },
    data () {
      return {
        newValue: this.value
      }
    },
    methods: {
      onChange (val) {
        this.newValue = val
        this.$emit('update', val)
      },
      onBlur () {
        this.$emit('blur', this.newValue)
      }
    }
  }
</script>
